<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
      <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>溯源碼信息</p>
      </div>

      <el-form>
        <el-form-item label="商品名稱 ：">
          <p style="color: #000000; word-wrap: break-word; white-space:normal">{{ originCodeData.goodsName }}</p>
        </el-form-item>

        <el-form-item label="溯源碼 ：">
          <p style="color: #000000;">{{ originCodeData.tracingSourceCode }}</p>
        </el-form-item>

        <el-form-item label="狀態 ：">
          <p style="color: #000000;">{{ originCodeData.status }}</p>
        </el-form-item>

        <el-form-item label="綁定帳號 ：">
          <p style="color: #000000;">{{ originCodeData.username }}</p>
        </el-form-item>

        <el-form-item label="綁定時間 ：">
          <p style="color: #000000;">{{ originCodeData.bindingTime }}</p>
        </el-form-item>

        <el-form-item label="備註 ：">
          <el-input
            v-model="comment"
            style="width: 300px; color: #000000;"
            autosize
            type="textarea"
            placeholder="請輸入備註"
          />
        </el-form-item>
      </el-form>

      <div class="bottomBtn">
        <div
          class="btn"
          @click="saveComment()"
        >
          保存
        </div>

        <div class="btn borderPurpleBtn" @click="$router.back()">
          返回
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import Goods from '@/components/memberGoods'
export default {
  data () {
    return {
      navBlock: '商城  /  溯源碼列表',
      navtitle:'詳情',
      originCodeData: '',
      comment: '',
      id: this.$route.query.id,
      type:'edit',
    }
  },
  created(){
    this.getDetails();
  },
  methods: {
    getDetails() {
      this.$get(`/request/tracing/source/detail?id=${this.id}`, this.$GLOBAL.jsonConfig)
      .then(res => {
        // console.log(res);
        if (res.code === '00000') {
          if (res.data.bindingTime) {
            res.data.bindingTime = this.$getTime(res.data.bindingTime);
          } else {
            res.data.bindingTime = '-';
          }
          if (!res.data.username) {
            res.data.username = '-';
          }
          if (res.data.status === 0) {
            res.data.status = '未綁定';
          } else if (res.data.status === 1) {
            res.data.status = '已綁定';
          } else if (res.data.status === 2) {
            res.data.status = '已作廢';
          }
          this.originCodeData = res.data;
          this.comment = res.data.comment;
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            center: true
          });
        }
      })
    },
    saveComment() {
      let _this = this;
      let commentParam = {
        id: _this.id,
        comment: _this.comment
      }
      _this.$post('/request/tracing/source/add/comment', commentParam, _this.$GLOBAL.jsonConfig)
      .then(res => {
        // console.log(res);
        if (res.code === '00000') {
          _this.$message({
            message: '保存成功',
            type: 'success',
            center: true
          });
          _this.$router.back();
        } else {
          _this.$message({
            message: res.message,
            type: 'error',
            center: true
          });
        }
      })
    }
  },
  components: {
    NavBar,
    Goods
  }
};
</script>>



// WEBPACK FOOTER //
// src/pages/market/memberGoods/editMemberGoods.vue